'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function (_Component) {
  (0, _inherits3.default)(Pagination, _Component);

  function Pagination() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Pagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Pagination.__proto__ || (0, _getPrototypeOf2.default)(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.previousRef = _this.previousRef.bind(_this), _this.nextRef = _this.nextRef.bind(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.previousButton.blur();
      this.nextButton.blur();
    }
  }, {
    key: 'handlePageChange',
    value: function handlePageChange(page) {
      return this.props.action.call(this, page);
    }
  }, {
    key: 'previousRef',
    value: function previousRef(button) {
      this.previousButton = button;
    }
  }, {
    key: 'nextRef',
    value: function nextRef(button) {
      this.nextButton = button;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentPage = _props.currentPage,
          totalPages = _props.totalPages;


      var previousPage = currentPage - 1;
      var nextPage = currentPage + 1;

      var previousProps = {
        className: 'previous',
        disabled: currentPage <= 1,
        action: this.handlePageChange.bind(this, previousPage),
        elementRef: this.previousRef.bind(this),
        iconLeft: 'chevronLeft',
        title: (0, _i18n2.default)('previousPage')
      };

      var nextProps = {
        className: 'next',
        disabled: currentPage >= totalPages,
        action: this.handlePageChange.bind(this, nextPage),
        elementRef: this.nextRef.bind(this),
        iconRight: 'chevronRight',
        title: (0, _i18n2.default)('nextPage')
      };

      return _react2.default.createElement(
        'div',
        { className: 'Pagination' },
        _react2.default.createElement(_.Button, previousProps),
        _react2.default.createElement(_.Button, nextProps)
      );
    }
  }]);
  return Pagination;
}(_react.Component);

Pagination.propTypes = {
  /**
   * The action to handle page change.
   */
  action: _propTypes2.default.func.isRequired,
  /**
   * The current page number.
   */
  currentPage: _propTypes2.default.number.isRequired,
  /**
   * The total number of pages.
   */
  totalPages: _propTypes2.default.number.isRequired
};
Pagination.defaultProps = {
  action: function action() {}
};
exports.default = Pagination;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Pagination.js
// module id = 281
// module chunks = 0